import React from 'react';
import DisplayCart from '../DisplayCart/DisplayCart';

const Cart = props => {
    const {products} = props;
    let totalCost = 0;
    for(const product of products){
        totalCost = totalCost + product.price;
    }
    return (
        <div>
            <div className="text-center mt-5 border bg-info text-light py-2">
                <h2>Card Details</h2>
            </div>
            <div className="border">
                    {
                        products.map(product => <DisplayCart product={product}></DisplayCart>)
                    }
                    <table className="table table-secondary border-0">
                    <tbody>
                        <tr>
                            <th scope="row">Total Items</th>
                            <td className="text-end">{products.length}</td>
                        </tr>
                        <tr>
                            <th scope="row">Total Costs</th>
                            <td className="text-end">{totalCost}</td>
                        </tr>
                    </tbody>
                    </table>
            </div>
        </div>
    );
};

export default Cart;


